import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'
import KeenSlider from 'keen-slider'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { slider: sliderEl } = zelektor(node)
    const frequency = parseInt(node.dataset.frequency) * 1000


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    const slider = new KeenSlider(sliderEl, {
        slidesPerView: 1,
        loop: true,
        duration: 1000,
        dragStart: () => stopInterval()
    })
    
    sliderEl.classList.add('is-initialized')

    let interval = setInterval(nextSlide, frequency)


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function nextSlide() {
        slider.next()
    }

    function stopInterval() {
        clearInterval(interval)
    }
})